import { TmStorageError } from '@/core/error/transport/tmStorageError'

export class TmStorageEntityNotFoundError extends TmStorageError {
  public name = 'TmStorageEntityNotFoundError'

  constructor(entityId: string) {
    super(`Not found entity in the storage. Entity id = "${entityId}"`)
  }
}
